export default () => ({
  onboard: null,
  testMode: false,
  products: [
    { text: 'Annual', value: 'annual', size: 'lg', required: true },
    { text: 'Monthly', value: 'monthly', size: 'lg', required: true },
    // { text: 'LITE - No Video/Audio', value: 'novideo', size: 'lg', required: true },
    { text: 'Per Event', value: 'perevent', size: 'lg', required: true }
  ],
  disable: false
})



// WEBPACK FOOTER //
// ./src/store/modules/onboard/state.js